<template>
    
</template>

<script>
    export default {
        name: "permission-tree"
    }
</script>

<style scoped>

</style>
